(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate-manual/assets/javascript/components/page-wrapper.js') >= 0) return;  svs.modules.push('/modules/tickets-validate-manual/assets/javascript/components/page-wrapper.js');
"use strict";


const Grid = svs.ui.ReactGrid.Grid;
setGlobal('svs.ticketsValidateManual.components.PageWrapper', _ref => {
  let children = _ref.children;
  return React.createElement(Grid, null, React.createElement("div", {
    className: "align-center validate-tickets-page u-flex u-flex-column f-body"
  }, React.createElement("div", {
    className: "padding-h-2 padding-bottom-2 padding-top-3"
  }, children)));
});

 })(window);